import {emptyGuid, isGuidEmpty} from "../../../../Utilities/commonUtilities";
import {INVENTORY_STATUS} from "../loanLibraryConstants";

export const loanLibraryCatalogItemModel = ({
                                                accessNumber,
                                                accessoriesAndParts,
                                                author,
                                                catalogNumber,
                                                cost,
                                                dateCreatedUtc,
                                                dateModifiedUtc,
                                                dateOfPurchase,
                                                description ,
                                                inventoryItems,
                                                isActive,
                                                isForInternalUse,
                                                keywords,
                                                loanLibraryCatalogId = emptyGuid,
                                                loanTerms,
                                                manufacturerId,
                                                mediaFormat,
                                                notes ,
                                                productName,
                                                productImageUrl,
                                                publicationDate,
                                                quantityCurrentlyAvailable,
                                                recommendedQuantity,
                                                relatedItems,
                                                totalQuantity,
                                                vendorId,
                                                whatsNewStartDate,
                                                whatsNewEndDate,
                                            }: Record<string, any> = {}) => ({
    accessNumber,
    accessoriesAndParts,
    author,
    catalogNumber,
    cost,
    dateCreatedUtc,
    dateModifiedUtc,
    dateOfPurchase,
    description: description || '',
    inventoryItems: Array.isArray(inventoryItems) 
        ? inventoryItems.map((item: Record<string, any>) => loanLibraryInventoryItemModel(item)) 
        : [],
    isActive,
    isForInternalUse: isForInternalUse || false,
    keywords,
    loanLibraryCatalogId,
    loanTerms,
    manufacturerId: isGuidEmpty(manufacturerId) ? null : manufacturerId,
    mediaFormat,
    notes: notes || '',
    productName,
    productImageUrl: productImageUrl || null,
    publicationDate,
    quantityCurrentlyAvailable,
    recommendedQuantity,
    relatedItems,
    totalQuantity,
    vendorId,
    whatsNewStartDate,
    whatsNewEndDate,
});
export const emptyLoanLibraryCatalogItemModel = loanLibraryCatalogItemModel();


export const loanLibraryInventoryItemModel = ({
                                                  loanLibraryInventoryId = emptyGuid,
                                                  loanLibraryCatalogItemId,
                                                  serialNumber,
                                                  assetNumber,
                                                  copyNumber = 1,
                                                  shelfLocation,
                                                  status,
                                                  lastCheckedOut,
                                                  dueDate,
                                                  notes,
                                                  cost,
                                                  catalogItemTitle,
                                                  catalogNumber,
                                                  shortId = '',
                                              }: Record<string, any> = {}) => ({
    loanLibraryInventoryId,
    loanLibraryCatalogItemId,
    serialNumber,
    assetNumber,
    copyNumber,
    shelfLocation,
    status: status || INVENTORY_STATUS.Available,
    lastCheckedOut,
    dueDate,
    notes,
    cost,
    catalogItemTitle,
    catalogNumber,
    shortId,
});

export const emptyInventoryItemModel = loanLibraryInventoryItemModel();
